import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import type { UIState } from '../types/store/ui.types'

export const useUIStore = create<UIState>()(
  devtools(
    persist(
      (set) => ({
        isSelectPortalCollapsed: false,
        setSelectPortalCollapsed: (collapsed) => set({ isSelectPortalCollapsed: collapsed }),
        isViewSelectionOpen: false,
        setViewSelectionOpen: (open) => set({ isViewSelectionOpen: open }),
        isMobileNavOpen: false,
        setMobileNavOpen: (open) => set({ isMobileNavOpen: open }),
      }),
      {
        name: 'ui-storage',
        partialize: (state) => ({ isSelectPortalCollapsed: state.isSelectPortalCollapsed }),
      },
    ),
    { name: 'UIStore', enabled: import.meta.env.DEV },
  ),
)
